import {
    AddItem,
    GetItems,
    UpdateItem,
    DeleteItem,
    PublishItem,
    AttachPlanToItem,
    DetachPlanFromItem,
} from "@/services/item";
import { GetCategories } from "@/services/category";
import { AddVariant, DeleteVariant } from "@/services/variant";

export const getItems = (context, params) => {
    context.commit("updateLoader", { getItems: true });
    return new Promise((resolve, reject) => {
        GetItems(params)
            .then(res => {
                context.commit("getItems", res.data.data);
                resolve(res.data.data);
            })
            .catch(err => reject(err))
            .finally(() => context.commit("updateLoader", { getItems: false }));
    });
};

export const addItem = (context, data) => {
    context.commit("updateLoader", { addItem: true });
    return new Promise((resolve, reject) => {
        AddItem(data)
            .then(res => {
                context.commit("addItem", res.data.data);
                resolve(res.data.data);
            })
            .catch(err => reject(err))
            .finally(() => context.commit("updateLoader", { addItem: false }));
    });
};

export const updateItem = (context, data) => {
    context.commit("updateLoader", { updateItem: true });
    const id = data.id;
    const payload = { ...data };
    delete payload.id;
    return new Promise((resolve, reject) => {
        UpdateItem(id, payload)
            .then(res => {
                context.commit("updateItem", res.data.data);
                resolve(res.data.data);
            })
            .catch(err => reject(err))
            .finally(() => context.commit("updateLoader", { updateItem: false }));
    });
};

export const deleteItem = (context, data) => {
    context.commit("updateLoader", { deleteItem: true });
    return new Promise((resolve, reject) => {
        DeleteItem(data)
            .then(res => {
                context.commit("deleteItem", res.data.data);
                resolve(res.data.data);
            })
            .catch(err => reject(err))
            .finally(() => context.commit("updateLoader", { deleteItem: false }));
    });
};

export const publishItem = (context, { id, force = false }) => {
    context.commit("updateLoader", { publishItem: true });
    return new Promise((resolve, reject) => {
        PublishItem(id, force)
            .then(res => {
                context.commit("publishItem", res.data.data);
                resolve(res.data.data);
            })
            .catch(err => reject(err))
            .finally(() => context.commit("updateLoader", { publishItem: false }));
    });
};

export const attachPlan = (context, { itemId, planId }) => {
    context.commit("updateLoader", { attachPlan: true });
    return new Promise((resolve, reject) => {
        AttachPlanToItem(itemId, planId)
            .then(res => {
                context.commit("attachPlan", res.data.data);
                resolve(res.data.data);
            })
            .catch(err => reject(err))
            .finally(() => context.commit("updateLoader", { attachPlan: false }));
    });
};

export const detachPlan = (context, { itemId, planId }) => {
    context.commit("updateLoader", { detachPlan: true });
    return new Promise((resolve, reject) => {
        DetachPlanFromItem(itemId, planId)
            .then(res => {
                context.commit("detachPlan", res.data.data);
                resolve(res.data.data);
            })
            .catch(err => reject(err))
            .finally(() => context.commit("updateLoader", { detachPlan: false }));
    });
};

export const getCategories = (context) => {
    context.commit("updateLoader", { getCategories: true });
    return new Promise((resolve, reject) => {
        GetCategories()
            .then(res => {
                context.commit("getCategories", res.data.data);
                resolve(res.data.data);
            })
            .catch(err => reject(err))
            .finally(() => context.commit("updateLoader", { getCategories: false }));
    });
};

export const addVariant = (context, data) => {
    context.commit("updateLoader", { addVariant: true });
    return new Promise((resolve, reject) => {
        AddVariant(data)
            .then(res => {
                context.commit("addVariant", { itemId: data.item_id, variant: res.data.data });
                resolve(res.data.data);
            })
            .catch(err => reject(err))
            .finally(() => context.commit("updateLoader", { addVariant: false }));
    });
};

export const removeVariant = (context, { itemId, variantId }) => {
    context.commit("updateLoader", { removeVariant: true });
    return new Promise((resolve, reject) => {
        DeleteVariant(variantId)
            .then(() => {
                context.commit("removeVariant", { itemId, variantId });
                resolve();
            })
            .catch(err => reject(err))
            .finally(() => context.commit("updateLoader", { removeVariant: false }));
    });
};

const ItemAction = {
    getItems,
    addItem,
    updateItem,
    deleteItem,
    publishItem,
    attachPlan,
    detachPlan,
    getCategories,
    addVariant,
    removeVariant,
};

export default ItemAction;
